import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { PricingBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { backgroundColor } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundColor";
import { backgroundImage } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundImage";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import {
  DesignProp,
  GeneralProp,
  MarginsProp,
  PaddingsProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { primaryBlockDefaultStyles } from "../../constants";
import { HomepageBlock8 as Block } from "./HomepageBlock8";
import { defaultData } from "./HomepageBlock8DefaultData";
import imagePreview from "./homepage_block_8_preview.png";

export const HomepageBlock8: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: imagePreview,
  },
  defaultData,
  meta: {
    name: "Homepage Block 8",
    nameI18n: "builder_ui.block_type.homepage.block_8",
    version: 1,
    category: [PricingBlock],
    props: {
      header: {
        name: "Header",
        nameI18n: "builder_ui.prop_type.header",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
        type: "children",
      },
      content: {
        name: "Content",
        nameI18n: "builder_ui.prop_type.content",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
        type: "children",
      },
      footer: {
        name: "Footer",
        nameI18n: "builder_ui.prop_type.footer",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
        type: "children",
      },
      styles: {
        name: "Styles",
        nameI18n: "builder_ui.prop_type.styles",
        prop: "styles",
        attributes: {
          backgroundColor: {
            ...backgroundColor,
            category: [DesignProp, GeneralProp],
            defaultValue: "var(--theme-website-color-background-secondary)",
          },
          backgroundImage: {
            ...backgroundImage,
            category: [DesignProp, GeneralProp],
          },
          padding: {
            ...padding,
            category: [DesignProp, PaddingsProp],
            defaultValue: primaryBlockDefaultStyles.padding,
          },
          margin: {
            ...margin,
            category: [DesignProp, MarginsProp],
            defaultValue: primaryBlockDefaultStyles.margin,
          },
        },
        type: "styles",
      },
    },
  },
};
